/**
 * @file
 * Mobile menu functionality.
 */

((Drupal, once) => {

  /**
   * Toggle trigger and submenu.
   *
   * @param props
   */
  function toggleSubMenu(props) {
    props._$trigger.classList.toggle('is-active');
    props._$subMenu.classList.toggle('opened');
  }

  /**
   * Initialize mobile menu.
   *
   * @param props
   */
  function init(props) {
    props._$trigger.addEventListener('click', () => {
      toggleSubMenu(props);
    });
  }

  Drupal.behaviors.mobileMenu = {
    attach(context) {
      const _$triggers = once('mobile-menu-trigger', '[data-mobile-menu-trigger]', context);

      // If there are triggers.
      if (_$triggers) {
        _$triggers.forEach(_$trigger => {
          const _$subMenu = _$trigger.parentElement.querySelector('[data-mobile-menu-sub]');

          init({_$trigger, _$subMenu});
        });
      }
    }
  };
})(Drupal, once);
